/**
 * Returns a boolean based on whether the column number >= to the scenario count
 * @param {number} column
 * @param {number} scenarioCount
 */
function isColumnHidden(column, scenarioCount) {
    return column >= scenarioCount;
}


export default isColumnHidden;